import React from 'react';
import styles from '../../App.module.css';
import FooterLinks from '../../components/layout/FooterLinks';
import BurgerHint from '../../components/layout/BurgerHint';

const FaqPage = ({ theme }) => {
  return (
    <div className={`${styles.container} ${theme === 'dark' ? styles.darkBackground : styles.lightBackground}`}>
      <div className={styles.staticContentBox}>
        <h1 className={styles.pageHeading}>❓ Frequently Asked Questions</h1>

        <BurgerHint />

        <ul>
          <li><a href="#important-tip" className="hover:underline">Important Tip</a></li>
          <li><a href="#adding-relationships" className="hover:underline">How to Add Relationships</a></li>
          <li><a href="#memory-and-corrections" className="hover:underline">Memory and Corrections</a></li>
          <li><a href="#relationship-memory-tips" className="hover:underline">Relationship Memory Tips</a></li>
          <li><a href="#giving-feedback" className="hover:underline">Giving Feedback</a></li>
        </ul>

        <hr style={{ margin: '1em 0' }} />

        <h2 id="important-tip" className={styles.sectionHeading}>✨ Important Tip</h2>
        <p>
          Daisy works best when she knows the important people, pets, and details in your life.
        </p>
        <p style={{ marginTop: '0.5em' }}>
          🧡 You can tell her things like:
        </p>
        <ul>
          <li>"My daughter is Julie."</li>
          <li>"My daughter Brandi lives nearby."</li>
          <li>"My best friend is Homer."</li>
          <li>"Elvis is my dog."</li>
          <li>"My mother is Trixie."</li>
        </ul>
        <p style={{ marginTop: '1em' }}>
          🧠 When Daisy understands who matters to you, her responses become more personal, natural, and meaningful.
        </p>

        <h2 id="adding-relationships" className={styles.sectionHeading}>🧠 How to Add Relationships</h2>
        <p>
          When introducing important people or pets that you want Daisy to remember, simple and direct phrasing works best.
        </p>
        <ul>
          <li>✅ <strong>Good:</strong> "Julie is my daughter."</li>
          <li>✅ <strong>Good:</strong> "Brandi is my daughter."</li>
          <li>✅ <strong>Good:</strong> "Ruppert is my brother."</li>
          <li>✅ <strong>Good:</strong> "Bojangles is my dog."</li>
          <li>⚠️ <strong>Less clear for adding a remembered relationship:</strong> "My daughters are outside playing."</li>
        </ul>
        <p>
          <em>Tip:</em> Daisy can understand natural conversation, but clear introductions help her remember the right thing.
        </p>

        <h2 id="memory-and-corrections" className={styles.sectionHeading}>🔄 Memory and Corrections</h2>
        <p>
          Daisy is designed to remember important relationship details over time, but she may occasionally misunderstand something.
        </p>
        <p style={{ marginTop: '0.5em' }}>
          If Daisy gets something wrong, you can correct her directly:
        </p>
        <ul>
          <li>"Rick Zipp is not my friend."</li>
          <li>"Katrina is my daughter, not my sister."</li>
          <li>"Brandi has a dog named Rocket."</li>
        </ul>
        <p style={{ marginTop: '1em' }}>
          For important changes, Daisy may ask you to confirm before updating memory.
        </p>

        <h2 id="relationship-memory-tips" className={styles.sectionHeading}>📝 Relationship Memory Tips</h2>
        <p>
          Daisy can understand normal conversation just fine. These examples only apply when you are adding,
          removing, or correcting important relationships that you would like Daisy to remember.
        </p>
        <ul>
          <li>✅ "My best friend is Jude."</li>
          <li>✅ "Trixie is my mother."</li>
          <li>✅ "Rocket is Miranda's dog."</li>
          <li>⚠️ Less clear for relationship memory: "My best friend and I are thinking about buying a boat and my cousin is visiting."</li>
        </ul>
        <p>
          When introducing, removing, or correcting a remembered relationship, clear statements work best.
          For everyday conversation, feel free to speak naturally.
        </p>

        <h2 id="giving-feedback" className={styles.sectionHeading}>📬 Giving Feedback</h2>
        <p>
          If Daisy misunderstands, forgets something, or responds oddly, please use the <strong>Feedback</strong> button in chat.
        </p>
        <p>
          Real feedback helps us improve Daisy’s memory, relationship understanding, and conversation quality. 🌼
        </p>

        <FooterLinks />
      </div>
    </div>
  );
};

export default FaqPage;